import { render, staticRenderFns } from "./indexnew.vue?vue&type=template&id=7b41ad57&scoped=true&"
import script from "./indexnew.vue?vue&type=script&lang=js&"
export * from "./indexnew.vue?vue&type=script&lang=js&"
import style0 from "./indexnew.vue?vue&type=style&index=0&id=7b41ad57&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b41ad57",
  null
  
)

export default component.exports